import styled, { css } from "styled-components"

const Layout = styled.div<{ checked: boolean }>`
  min-height: 48px;
  padding: 12px;
  cursor: pointer;

  box-sizing: border-box;

  display: grid;
  grid-template-columns: 1fr 24px;
  align-items: center;

  border-radius: 4px;

  background: ${(props) => props.theme.colors.primary99};
  color: ${(props) => props.theme.colors.primary10};

  &:hover {
    color: ${(props) => props.theme.colors.primary40};

    .--checkbox-box {
      border: 2px solid ${(props) => props.theme.colors.primary40};
    }
  }

  ${(props) =>
    props.checked &&
    css`
      background: ${props.theme.colors.primary95};
      box-shadow: ${props.theme.shadow.elevation1};
    `}
`

const RadioCircle = styled.div<{ checked: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 3px solid ${(props) => props.theme.colors.primary40};
`

const RadioCircleInner = styled.div<{ checked: boolean }>`
  display: ${(props) => (props.checked ? "block" : "none")};
  background: ${(props) => props.theme.colors.primary40};
  width: 12px;
  height: 12px;
  border-radius: 50%;
`

export interface RadioProps {
  checked: boolean
  onChange: (value: boolean) => void
}

const Content = styled.span``

const Radio: React.CFC<RadioProps> = ({ checked, onChange, children }) => {
  return (
    <Layout checked={checked} onClick={() => onChange(!checked)}>
      <Content>{children}</Content>
      <RadioCircle checked={checked}>
        <RadioCircleInner checked={checked} />
      </RadioCircle>
    </Layout>
  )
}

export default Radio
